import * as _ from 'lodash';

import IAttribute = ZoneIQCalibration.IAttribute;
import { AttributeType } from '../../../shared/enums';
import { LinksValidator } from 'src/shared/zoneiqui/components/links/links.validator';
import { IAttributeModel } from 'src/app/interfaces/attribute-model.interface';
import { isEmptyString } from 'src/shared/zoneiqui/components/links/empty-string.validator';

export abstract class AttributeModel implements IAttributeModel {

    properties: string[] = [];
    static parameters = [
        'ZoningCodeId',
        'TableFieldId',
        'TableFieldOption',
        'ParentId',
        'ParentType',
        'TableType',
    ];

    Id?: number;
    AttributeType?: number;
    AttributeValue?: string;
    Description?: string;

    IsEditableMode?: boolean;
    originalState: any;

    constructor(data: IAttribute, properties: string[]) {
        this.properties = properties;
        Object.assign(this, AttributeModel.getPreparedData(data, properties));
        this.IsEditableMode = false;
        this.originalState = AttributeModel.getPreparedData(data, properties) as IAttribute;
    }

    static getIdentifier(identifierData: any): string {
        return AttributeModel.parameters.reduce((result, parameter) => {
            if (!_.has(identifierData, parameter)) {
                return result;
            }
            return `${result}-${identifierData[parameter]}`;
        }, '');
    }

    get isNew() {
        return !this.Id;
    }

    get IsChanged() {
        return !_.isEqual(this.getPreparedData(), this.originalState);
    }

    get IsEmpty() {
        return !this.AttributeValue;
    }

    get isValid() {
        return this.isLink
            ? LinksValidator.isLinkValueValid(this.AttributeValue) && !isEmptyString(this.Description)
            : true;
    }

    get isLink() {
        return this.AttributeType === AttributeType.LINK;
    }

    get isComment() {
        return this.AttributeType === AttributeType.COMMENT;
    }

    get isAssumption() {
        return this.AttributeType === AttributeType.ASSUMPTION;
    }

    static getPreparedData(data, properties) {
        return _.pick(data, properties);
    }

    getPreparedData() {
        return AttributeModel.getPreparedData(this, this.properties);
    }

    clone() {
        return new (this.constructor as any)(this.getPreparedData());
    }

    revertChanges() {
        if (!this.IsChanged) {
            return false;
        }

        Object.assign(this, this.originalState);
    }
}
